import { createSlice } from '@reduxjs/toolkit';
import {
    fetchConsents,
    addConsent,
    getConsentById,
    editConsent,
    deleteConsent
} from '../actions/consent';

export const consentSlice = createSlice({
    name: 'consent',
    initialState: {
        loading: false,
        data: [],
        addedConsent: null,
        consentToEdit: null,
        consentToEditLoading: false,
        editedConsent: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // FETCH CONSENTS
            .addCase(fetchConsents.pending, (state) => { state.loading = true })
            .addCase(fetchConsents.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchConsents.rejected, (state) => { state.loading = false })
            // ADD CONSENT
            .addCase(addConsent.pending, (state) => { state.loading = true })
            .addCase(addConsent.fulfilled, (state, action) => {
                state.loading = false;
                state.addedConsent = action.payload;
            })
            .addCase(addConsent.rejected, (state) => { state.loading = false })
            // GET CONSENT BY ID
            .addCase(getConsentById.pending, (state) => { state.consentToEditLoading = true })
            .addCase(getConsentById.fulfilled, (state, action) => {
                state.consentToEditLoading = false;
                state.consentToEdit = action.payload;
            })
            .addCase(getConsentById.rejected, (state) => { state.consentToEditLoading = false })
            // EDIT CONSENT
            .addCase(editConsent.pending, (state) => { state.consentToEditLoading = true })
            .addCase(editConsent.fulfilled, (state, action) => {
                state.consentToEditLoading = false;
                state.editedConsent = action.payload;
            })
            .addCase(editConsent.rejected, (state) => { state.consentToEditLoading = false })
            // DELETE CONSENT
            .addCase(deleteConsent.pending, (state) => { state.loading = true })
            .addCase(deleteConsent.fulfilled, (state) => { state.loading = false })
            .addCase(deleteConsent.rejected, (state) => { state.loading = false });
    }
});

export default consentSlice.reducer;
